import { Atom } from 'AppReact';
import styled, { css, keyframes } from "styled-components";

const backgroundAnimation = keyframes`
  0% {
    opacity: 0;
  }
  70% {   
    opacity: 1;
  }
  100% {   
    opacity: 1;
  }
`;

const template = styled.img`
  ${({ displayState }) => css`
    position: absolute; 
    top: ${displayState?.top ?? '0px'}; 
    left: ${displayState?.left ?? '0px'}; 
    z-index: 10000; 
    width: 100%; 
    min-width: ${displayState?.minWidth ?? ''};
    height: ${displayState?.height ?? '100%'};
    animation: 1.5s ${backgroundAnimation} ease-out;
  `}
`;

export default Atom({ type: 'image', datatype: 'string', template })
